<!--File: cgp-idle.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 6/8/2017-->
<!--Desc: CGP logout warning dialog.-->
<!--Other Contributors:-->

<h1 i18n mat-dialog-title>Your Session is About to Expire!</h1>

<div mat-dialog-content>
    <div class="alert alert-danger">You have <strong>{{ serviceRef.timeLeft }}</strong> seconds before your session expires.</div>
</div>

<div mat-dialog-actions class="cgp-dialog-action">
    <span class="cgp-flex-fill"></span>
    <button i18n mat-raised-button mat-dialog-close (click)="logout()">Logout</button>
    <button i18n mat-raised-button mat-dialog-close color="primary" (click)="serviceRef.stayLoggedIn()">Stay Logged In</button>
</div>